import { getUser } from '../services/store-service';
import { fetchUser } from '../actions/users';

import { docPermissions, BOT } from '../constants';

const docPermissionsCollection = docPermissions();

export const getRoleIndefiniteArticle = roleId => {
    switch (roleId) {
        case 'owner':
        case 'manager':
            return 'an';

        default:
            return 'a';
    }
}

export const resolveUsers = ({
    userIds,
    forcePromise,
    forceArray
}) => {
    let shouldFetch = false;

    const resolvedUsers = userIds.filter(user => !!user).map(u => {
        const userId = u.id || u;

        if (userId === 'orbit') {
            return {
                id: 'orbit',
                name: BOT.name,
                avatar: BOT.image,
                online: true,
                bot: true
            }
        }

        const user = getUser(userId);

        if (!user) {
            shouldFetch = true;

            return fetchUser(userId);
        }

        return user;
    });

    if (!shouldFetch) {
        if (forcePromise) {
            return Promise.resolve(resolvedUsers);
        }

        return resolvedUsers;
    } else {
        if (forceArray) {
            Promise.all(resolvedUsers)

            return resolvedUsers;
        }

        return Promise.all(resolvedUsers);
    }
}

export const getDocPermissionLabel = permissionId => {
    const permission = docPermissionsCollection.find(permission => permission.id === permissionId);
    return (permission || docPermissionsCollection[0]).title;
}

export const testUserAgainstString = (user, term, labels) => {
    if (user.email.toLowerCase().indexOf(term) >= 0) {
        return true;
    }

    if (user.name.toLowerCase().indexOf(term) >= 0) {
        return true;
    }

    if (labels && user.labels?.map(id => labels.find(label => label.id === id)?.name).join('&&').toLowerCase().indexOf(term) >= 0) {
        return true;
    }

    return false;
}
